var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 grey--text align-center"},[_vm._v("\n  © Ірина Семененко, лютий 2011  - "+_vm._s(new Date().getFullYear())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }